import type { EachRowHeaderConfig } from '../types/layout';

export interface ResolvedRowHeader {
  style: 'none' | 'badge' | 'numbered' | 'title-field';
  label: string | null;
  badgeVariant: string;
  titleField: string | null;
}

export function resolveRowHeader(
  config: EachRowHeaderConfig | undefined,
  index: number,
  rowValues?: Record<string, unknown>,
): ResolvedRowHeader {
  const style = config?.style ?? (config?.labelTemplate ? 'badge' : 'none');

  if (style === 'none') {
    return { style, label: null, badgeVariant: config?.badgeVariant ?? 'success', titleField: null };
  }

  if (style === 'title-field') {
    const titleField = config?.titleField ?? null;
    const raw = titleField != null ? rowValues?.[titleField] : null;
    const label = raw != null && String(raw).trim() !== '' ? String(raw) : `Item ${index + 1}`;
    return {
      style,
      label,
      badgeVariant: config?.badgeVariant ?? 'success',
      titleField,
    };
  }

  if (style === 'numbered') {
    const template = config?.labelTemplate ?? '#{n}';
    return {
      style,
      label: applyLabelTemplate(template, index),
      badgeVariant: config?.badgeVariant ?? 'success',
      titleField: null,
    };
  }

  // badge (default when labelTemplate provided)
  const template = config?.labelTemplate ?? 'Item #{n}';
  return {
    style: 'badge',
    label: applyLabelTemplate(template, index),
    badgeVariant: config?.badgeVariant ?? 'success',
    titleField: null,
  };
}

function applyLabelTemplate(template: string, index: number): string {
  return template.replace(/\{n\}/g, String(index + 1)).replace(/#\{n\}/g, String(index + 1));
}
